import React from "react";
import { DropDown } from "~/common/DropDown";
import { DesktopMenu } from "./DesktopMenu";

export function Desktop(props: {
  userName?: string;
  color?: string;
  backgroundColor?: string;
}) {
  const refParent = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);

  // logged in user
  if (props.userName) {
    return (
      <div className="tw:relative tw:w-full">
        <div
          ref={refParent}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          className="tw:flex tw:items-center tw:justify-center tw:w-full tw:h-full"
        >
          <a href="/profile">
            <div
              className="tw:text-base! tw:font-semibold"
              style={{
                color: props.color ?? undefined,
                backgroundColor: props.backgroundColor ?? undefined,
              }}
            >
              Welcome,{" "}
              <span className="tw:text-[#6c8cfc]">{props.userName}</span>
            </div>
          </a>
        </div>

        {open && (
          <DropDown
            refParent={refParent}
            gapTop={0}
            gapLeft={-50}
            gapRight={-50}
            zIndex={1001}
            center="parent"
            onMouseLeave={() => setOpen(false)}
            onMouseEnter={() => setOpen(true)}
          >
            <DesktopMenu
              color={props.color}
              backgroundColor={props.backgroundColor}
            />
          </DropDown>
        )}
      </div>
    );
  }

  // not logged in user
  return (
    <div className="tw:flex tw:items-center tw:justify-center tw:w-full tw:h-full">
      <a href="/profile">
        <div
          className="tw:text-base tw:font-semibold"
          style={{
            color: props.color ?? undefined,
            backgroundColor: props.backgroundColor ?? undefined,
          }}
        >
          Sign In/Create an account
        </div>
      </a>
    </div>
  );
}
